document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown).getTime();
    if (!target) return;
    const tick = () => {
      const diff = Math.max(0, target - Date.now());
      const vals = {
        days: Math.floor(diff / 86400000),
        hours: Math.floor(diff / 3600000) % 24,
        minutes: Math.floor(diff / 60000) % 60,
        seconds: Math.floor(diff / 1000) % 60
      };
      Object.entries(vals).forEach(([k,v]) => {
        const n = el.querySelector(`[data-${k}]`); if(n) n.textContent = String(v).padStart(2,'0');
      });
    };
    tick(); setInterval(tick, 1000);
  });
});
